var _rect, _rect2, _rect3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPopupRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 22,
    width: 21,
    height: 21,
    rx: 2.5,
    transform: "rotate(-90 0.5 22)",
    fill: "#F3F3F3",
    stroke: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.35,
    y: 16.15,
    width: 8.52533,
    height: 14.9151,
    rx: 0.65,
    transform: "rotate(-90 3.35 16.15)",
    fill: "white",
    stroke: "#FFB600",
    strokeWidth: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.35,
    y: 16.15,
    width: 8.52533,
    height: 8.57536,
    rx: 0.65,
    transform: "rotate(-90 3.35 16.15)",
    fill: "#FFB600",
    fillOpacity: 0.5,
    stroke: "#FFB600",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00336 9.5L4.92974 8.57362",
    stroke: "#FFB600",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89789 9.48047L4.00315 8.58573",
    stroke: "#FFB600",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPopupRow);
export default __webpack_public_path__ + "static/media/ic-popup-row.d9944662eb14e2284b1d425cbf3757c6.svg";
export { ForwardRef as ReactComponent };